import { Card, CardContent } from '@mlm/ui';
import { useRanks } from '../../lib/hooks/use-ranks';
import { RankShowcase } from './rank-showcase';

/**
 * Dashboard "Ranks" card — the same showcase as the storefront section, with
 * the active slot's current rank highlighted. The caller gates it on the
 * tenant's `rankShowcase` flag; it hides itself when there are no ranks.
 */
export function RankShowcasePanel({ currentRankCode }: { currentRankCode?: string | null }) {
  const ranksQ = useRanks();
  const ranks = ranksQ.data ?? [];
  if (ranks.length === 0) return null;
  return (
    <Card>
      <CardContent className="p-6">
        <p className="text-caption font-medium uppercase tracking-[0.1em] text-muted-foreground">
          Ranks
        </p>
        <RankShowcase ranks={ranks} highlightCode={currentRankCode} className="mt-3" />
      </CardContent>
    </Card>
  );
}
